import React from 'react';

const Error = () => (
  <div>
    <h1>Error, Please Click on Home to go back</h1>
  </div>
);

export default Error;
